import {HttpException} from "./http.exception.js";

/**
 * 401 Unauthorized Exception
 */
export class UnauthorizedException extends HttpException {
    constructor(message: string = "Unauthorized", errorBody?: unknown, cause?: Error) {
        super(401, message, errorBody, cause);
    }
}
